import { render } from "./KeyBox.vue?vue&type=template&id=05f9ad7a&scoped=true"
import script from "./KeyBox.vue?vue&type=script&lang=js"
export * from "./KeyBox.vue?vue&type=script&lang=js"

import "./KeyBox.vue?vue&type=style&index=0&id=05f9ad7a&lang=scss&scoped=true"
import "./KeyBox.vue?vue&type=style&index=1&id=05f9ad7a&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f9ad7a"]])

export default __exports__